// Line Item Form — budget & pricing
export const MIN_LINE_ITEM_BUDGET_OVERRIDE_LD_FLAG =
  'release-26.6-account-manager-min-line-item-budget-override-enabled';

// Line Item Form — ad format pricing
// TODO [ssat-17934]: Remove when FF cleanup is complete. See docs/business-logic/estimated-cost-ad-format/README.md
export const AD_FORMAT_PRICING_CALCULATION_FLAG = 'release-ssat-17934-ad-format-premium-pricing-feature';

// Ad Gallery — Creative Studio label
// TODO [ssat-19135]: Temporary release flag — remove hook/allowlist entries and always render label when isDisneyAi is true.
export const CREATIVE_STUDIO_LABEL_ENABLED_FLAG = 'release-ssat-19135-creative-studio-label-enabled';

// TODO [ssat-18596]: Temporary release flag — remove after this feature is released.
export const CAMPAIGN_TIMEZONE_FULL_ALLOWLIST_FLAG = 'release-ssat-18592-campaign-timezone-full-allowlist';

// Forgot Password — silent invite resend for users who never completed onboarding
// TODO [ssat-17771]: Temporary release flag - remove hook/allowlist entries and always run the
// silent resend once the feature is enabled in PROD and QA-validated.
export const INVITE_RESEND_ENABLED_FLAG = 'dcm-resend-email-for-failed-onboarding';

// Ad Gallery — unified creative management view (Ads + Assets tabs)
// TODO [ssat-18814]: Remove when the new Ad Gallery fully replaces the current one — delete AdGalleryHoC,
// route pages/NewAdGallery directly, and remove pages/AdGallery.
export const UNIFIED_AD_GALLERY_ENABLED_FLAG = 'ads-6310-creative-management-unified-ad-gallery';

// New Ad Gallery — inline creative name edit on Ad Details
// TODO [ssat-20339]: Remove when the edit affordance is fully rolled out. See
// docs/business-logic/new-ad-gallery-creative-name-edit/README.md
export const AD_GALLERY_CREATIVE_NAME_EDIT_FLAG = 'ssat-20339-new-ad-gallery-ad-selector-creative-name-edit';

// Analytics — Amplitude event tracking
export const DCM_AMPLITUDE_ENABLED_FLAG = 'dcm-amplitude-enabled';

// Line Item Form — Ad Format popup, Video Plus format
export const AD_FORMAT_POPUP_VIDEO_PLUS_FLAG = 'ad-format-popup-video-plus';

// Ad Account — Billable Ad Server, deprecate 'Nielsen' in favor of 'Nielsen DTA P2+'
export const NIELSEN_DTA_P2_PLUS_ENABLED_FLAG = 'nielsen-dta-p2-plus-enabled';

// New Ad Gallery — VAST creative flow (upload + details modal)
// TODO [ssat-20423]: Remove when VAST flow is fully rolled out. See docs/business-logic/new-ad-gallery-vast-flow/README.md
export const NEW_AD_GALLERY_VAST_FLOW_FLAG = 'ssat-20423-new-ad-gallery-vast-flow';

// Campaigns — Ad Format filter on the campaigns list and admin campaigns list
// TODO [ssat-20348]: Remove when the Ad Format filter is fully rolled out.
export const CAMPAIGNS_AD_FORMAT_FILTER_FLAG = 'ssat-20348-campaigns-ad-format-filter';
